
import { defineComponent } from 'vue'
import CustomContainer from '@/components/common/CustomContainer.vue'
import page from './page.json'
export default defineComponent({
  components: {
    CustomContainer
  },
  setup () {
    return {
      page
    }
  }
})
